import { CustomerOrdersQueryParams } from 'src/api/customer/orders';
import { action } from 'src/store/actions';

/* Customer Orders */
export const FETCH_CUSTOMER_ORDERS = 'FETCH_CUSTOMER_ORDERS';
export const REQUEST_CUSTOMER_ORDERS = 'REQUEST_CUSTOMER_ORDERS';
export const SUCCESS_CUSTOMER_ORDERS = 'SUCCESS_CUSTOMER_ORDERS';
export const FAILURE_CUSTOMER_ORDERS = 'FAILURE_CUSTOMER_ORDERS';

export const fetchCustomerOrders = (pageable?: CustomerOrdersQueryParams) =>
    action(FETCH_CUSTOMER_ORDERS, { pageable });
export const requestCustomerOrders = () => action(REQUEST_CUSTOMER_ORDERS);
export const requestCustomerOrdersSuccess = (response: any) => action(SUCCESS_CUSTOMER_ORDERS, { response });
export const requestCustomerOrdersFailure = (error: any) => action(FAILURE_CUSTOMER_ORDERS, { error });
